export const deepUpdate = (obj, pathArray, value) => {
    if (!pathArray.length)
        return obj;
    const [key, ...rest] = pathArray;
    return Object.assign(Object.assign({}, obj), { [key]: rest.length > 0 ? deepUpdate(obj[key] || {}, rest, value) : value });
};
//# sourceMappingURL=deep-update.js.map